import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FormInput } from "../Components/Form/FormElements";
import FormToast from "../Components/Form/FormToast";
import useQuery from "../Hooks/useQuery";
import logo from "../IMG/Nubeteck.svg";
import loginImg from "../IMG/Edit.svg";
import { recuperarContrasenia } from "../Redux/reducers/usuariosSlice";

export default function ChangePassword() {
    const {
        handleSubmit,
        control,
        formState: { errors },
      } = useForm();
    
      const [successCode, setSuccessCode] = useState(0);
      const navigate = useNavigate();
      const dispatch = useDispatch();
  const query = useQuery()
    
      const onSubmit = async (data) => {
        let result;
        let { payload } = await dispatch(recuperarContrasenia({...data,token:query.get("id")  }));
          result = payload;
        if (result.success) {
            setSuccessCode(1);
          setTimeout(() => {
            setSuccessCode(0)
            navigate("/login")
        }, 3000);
        } else {
          setSuccessCode(2);
          setTimeout(() => setSuccessCode(0), 3000);
        }
      };
    
  const settingsForm = {
  
    NewPassword: {
      label: "Nueva contraseña",
      type: "password",
      placeholder: "Nueva contraseña",
      defaultValue: "",
      icon:(<i className='material-icons input-symbol'></i>),
      required: true,
      rules: {
        required: true,
      },
    },
    ConfirmNewPassword: {
      label: "Confirme la contraseña",
      type: "password",
      placeholder: "Confirme la contraseña",
      defaultValue: "",
      icon:(<i className='material-icons input-symbol'></i>),
      required: true,
      rules: {
        required: true,
      },
    },
  };
    
      const formInputs = Object.keys(settingsForm).map((e) => {
        const { rules, defaultValue } = settingsForm[e];
        return (
          <section key={e}>
            <Controller
              name={e}
              control={control}
              rules={rules}
              defaultValue={defaultValue}
              render={({ field }) => (
                <div>
                  <FormInput
                    error={errors[e] && "Este campo es requerido"}
                    value={field.value}
                    onChange={field.onChange}
                    {...settingsForm[e]}
                  />
                </div>
              )}
            />
          </section>
        );
      });
    
      return (
        <div id="principal-container" className="login-container">
          <main id="main" className="container-col-75">
            <form onSubmit={handleSubmit(onSubmit)}>
            <FormToast
                    code={successCode}
                    title={successCode == 2 ? "¡Algo anda mal!" : "Contraseña cambiada con exito"}
                    desc={successCode == 2 ? "Ocurrio un error" : "Regresando al login"}
                  />
              <div className="logo-container">
                <img src={logo} alt="Logo empresa" />
              </div>
              <h1 className="grey-text">Recuperar contraseña</h1>
    
              {formInputs}
            
              <input
                type="submit"
                className="btn btn-primary"
                value="Enviar"
              />
            </form>
          </main>
          <div>
            <h3 className="grey-text">SISTEMA DE GESTIÓN ESTADÍSTICO</h3>
            <img src={loginImg} alt="Ilustración estadisticas" />
          </div>
        </div>
      );
}
